import { render, staticRenderFns } from "./ClinicList.vue?vue&type=template&id=7bc84dee&scoped=true"
import script from "./ClinicList.vue?vue&type=script&lang=js"
export * from "./ClinicList.vue?vue&type=script&lang=js"
import style0 from "./ClinicList.vue?vue&type=style&index=0&id=7bc84dee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc84dee",
  null
  
)

export default component.exports